import { ResourceMapperNotificationTypes } from '../types';
import { CropwiseNotification } from '../../../models/index';
import i18n from 'i18next';

export const mapNotificationMessage = (
  note_type: ResourceMapperNotificationTypes | undefined,
  note: any,
) => {
  let notification: CropwiseNotification = {
    type: 'ERROR',
    message: 'Error',
    description: '',
    placement: 'topRight',
  };
  switch (note_type) {
    case ResourceMapperNotificationTypes.CROPWISE_RESOURCE_ERROR:
      notification.message = i18n.t(
        'resource_mapper.notifications.unable_to_locate_cw_resource_data',
      );
      break;
    case ResourceMapperNotificationTypes.RESOURCE_ERROR:
      notification.message = i18n.t('resource_mapper.notifications.unable_to_locate_unmapped');
      break;
    case ResourceMapperNotificationTypes.NO_SELECTED_INSTANCES:
      notification.message = i18n.t('resource_mapper.notifications.unable_to_update');
      notification.description = i18n.t('resource_mapper.notifications.please_select_at_least_one');
      break;
    case ResourceMapperNotificationTypes.NO_SELECTED_CROPWISE_RESOURCE:
      notification.message = i18n.t('resource_mapper.notifications.unable_to_update');
      notification.description = i18n.t(
        'resource_mapper.notifications.please_select_a_cw_resource',
      );
      break;
    case ResourceMapperNotificationTypes.PATCH_ERROR:
    case ResourceMapperNotificationTypes.UNDO_PATCH_ERROR:
      notification.message = i18n.t('resource_mapper.notifications.unable_to_patch');
      notification.description = i18n.t('resource_mapper.notifications.try_again');
      break;
    case ResourceMapperNotificationTypes.IGNORE_PRODUCT_FAILURE:
      notification.message = i18n.t('resource_mapper.notifications.unable_to_ignore_product');
      notification.description = i18n.t('resource_mapper.notifications.try_again');
      break;
    case ResourceMapperNotificationTypes.IGNORE_PRODUCT_SUCCESS:
      notification.type = 'SUCCESS_NO_UNDO';
      notification.message = i18n.t('resource_mapper.notifications.product_ignored');
      break;
    case ResourceMapperNotificationTypes.PATCH_FAIL:
      notification.type = 'ERROR';
      notification.message = note.message;
      notification.description = note.description;
      break;
    case ResourceMapperNotificationTypes.PATCH_SUCCESS:
      notification.type = note.type;
      notification.message = note.message;
      notification.description = note.description;
      notification.referenceId = note.referenceId;
      break;
    case ResourceMapperNotificationTypes.CREATE_NEW_FIELD_IN_PROGRESS:
      notification.type = 'SUCCESS_NO_UNDO';
      notification.message = note.message;
      notification.description = note.description;
      break;
    case ResourceMapperNotificationTypes.CREATE_NEW_FIELD_ERROR:
      notification.message = note.message;
      notification.description = note.description;
      break;
    case ResourceMapperNotificationTypes.NO_SELECTED_INSTANCES_CREATE_NEW_FIELD:
      notification.message = i18n.t(
        'resource_mapper.notifications.unable_to_open_create_new_field_form',
      );
      notification.description = i18n.t('resource_mapper.notifications.please_select_at_least_one');
      break;
    default:
      return notification;
  }
  return notification;
};
